import { render, staticRenderFns } from "./grammar_report_v3.vue?vue&type=template&id=38118303&scoped=true&"
import script from "./grammar_report_v3.vue?vue&type=script&lang=js&"
export * from "./grammar_report_v3.vue?vue&type=script&lang=js&"
import style0 from "./grammar_report_v3.vue?vue&type=style&index=0&id=38118303&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38118303",
  null
  
)

export default component.exports